<div class="wrapper">
    <header class="page-header"></header>
    <main class="page-main" style="text-align: center;" >    
        <div class="center-page" >
            <div class="loginForm">
                <!-- <p id="encabezado" style="font: normal normal 700 22px/30px Montserrat;text-align: center;">Plataforma desactivada por periodo de vacaciones Unidades Educativas.</p> -->
                <p id="encabezado">Ingrese a continuación sus <span class="boldText">datos de acceso</span> a la zona de intranet:</p> 

                <form class="form" [formGroup]="loginForm" (ngSubmit)="login()">
                    <div class="field">
                        <input  id="usuario" type="text" formControlName="usuario" placeholder="Usuario" style="background: #F5F6FC 0% 0% no-repeat padding-box;
                        border-radius: 10px;
                        opacity: 1;
                        height: 50px;">
                        <input id="password" type="password" formControlName="password" placeholder="Contraseña" style="background: #F5F6FC 0% 0% no-repeat padding-box;
                        border-radius: 10px;
                        opacity: 1;
                        height: 50px;" >
                    </div>
                   <div class="error" *ngIf="!loginOK" >Usuario o Contraseña Incorrecta</div>
                    <button class="button" mat-flat-button type="submit" style="margin: 0px;">INICIAR SESIÓN</button>
                </form>
            </div> 
        </div>   
    </main>
    <footer class="page-footer">
        <div class="row">
                    
            <div class="col-sm-11 mt-5">
                <!--p><span  style="color: #f80505;font-size:26px" >Sistema en Mantención</span></p-->
                <p (click)="recuperarPassword()" class="passwordlink">
                        <span>Recuperar Password</span>
                </p>
                <p>Escritorio digital del Jardín Infantil</p>
            </div>
            <div class="col-sm-1 mt-5">
                <img src="../../assets/icons/JUNJI__JUNJI-logo.svg">
            </div>
        </div>
        <div class="col-sm-11 mt-5">
            <p>
                Versión:<b>20260717</b>
            </p>
            </div>
    </footer>
</div>
